import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function PSVRIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M4.32383 15.2065C3.72418 15.6581 3.92407 16.5161 5.20332 16.9226C6.52255 17.4194 7.96171 17.5548 9.36089 17.2839C9.44085 17.2839 9.5208 17.2387 9.56078 17.2387V15.7032L8.20157 16.2C7.68187 16.3806 7.16218 16.4258 6.64248 16.2903C6.24271 16.1548 6.32267 15.8839 6.80239 15.6581L9.56078 14.5742V12.9032L5.72302 14.3935C5.2433 14.5742 4.76358 14.8452 4.32383 15.2065ZM13.5984 8.43226V12.8129C15.2375 13.7161 16.5167 12.8129 16.5167 10.4645C16.5167 8.07097 15.7572 6.9871 13.5584 6.12903C12.3991 5.67742 11.1998 5.27097 10.0005 5V18.0516L12.7989 19V8.02581C12.7989 7.52903 12.7989 7.16774 13.1187 7.30323C13.5584 7.43871 13.5984 7.93548 13.5984 8.43226ZM18.7954 14.1677C17.6361 13.7161 16.3968 13.5355 15.1975 13.671C14.5579 13.7161 13.9582 13.8968 13.3985 14.1226L13.2786 14.1677V15.929L15.8771 14.8452C16.3968 14.6645 16.9165 14.6194 17.4362 14.7548C17.8359 14.8903 17.756 15.1613 17.2763 15.3871L13.2786 17.0581V18.7742L18.7954 16.471C19.1952 16.2903 19.5549 16.0645 19.8748 15.7032C20.1546 15.2516 20.0347 14.6194 18.7954 14.1677Z"
        fill="currentColor"
      />
    </svg>
  );
}
